import PanelSocial from './Social';

export default PanelSocial;
